<template>
  <div class="main projects">
    <h1 class="page-title">Projects</h1>
    <div class="filter-dropdown">
      <div
        class="filterBtn"
        v-for="category in categories"
        v-bind:class="{ active: currentFilter === category.name }"
        v-on:click="setFilter(category.name)"
        :key="category.name"
      >
        <i :class="iconClass(category.icon)"></i>
        {{ category.name }}
      </div>
    </div>
    <div class="card-container">
      <ProjectCard
        v-for="card in getFilteredCards()"
        :key="card.name"
        :data="card"
      />
    </div>
  </div>
</template>

<script>
import ProjectCard from "./ProjectCard";
import { projects } from "@/data/projects.js";

export default {
  name: "Projects",
  components: {
    ProjectCard
  },
  data() {
    return {
      currentFilter: "ALL",
      categories: [
        {
          name: "ALL",
          icon: "check"
        },
        {
          name: "HIGHLIGHTS",
          icon: "star"
        },
        {
          name: "WEB DEV",
          icon: "desktop"
        },
        {
          name: "TECH",
          icon: "robot"
        },
        {
          name: "DESIGN",
          icon: "pencil-alt"
        },
        {
          name: "CONTENT",
          icon: "quote-left"
        }
      ],
      columnNumber: 1,
      cards: projects
    };
  },
  methods: {
    setFilter(filter) {
      this.currentFilter = filter;
    },
    getFilteredCards() {
      var filtered = [];

      if (this.currentFilter === "ALL") {
        return this.cards;
      }
      for (var i = 0; i < this.cards.length; i++) {
        if (this.cards[i].categories.includes(this.currentFilter)) {
          filtered.push(this.cards[i]);
        }
      }
      return filtered;
    },
    iconClass(iconName) {
      return `fas fa-${iconName}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";

.projects {
  display: flex;
  flex-direction: column;
  align-items: center;

  .card-container {
    display: grid;
    grid-template-columns: 1fr;

    .card {
      max-width: 400px;
      border-radius: 10px;
      background-color: white;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
      margin-bottom: 40px;
    }
  }

  .filter-dropdown {
    margin-bottom: 30px;

    .filterBtn {
      display: inline-block;
      font-size: $font-XS;
      font-weight: 600;
      margin: 0 10px 10px 0;
      text-decoration: none;
      position: relative;
      transition: all 0.3s;

      background: white;
      border: 2px solid #dadce0;
      color: $dark-grey;
      padding: 5px 20px 5px 5px;
      border-radius: 2em;

      i {
        color: $dark-grey;
        padding: 10px;
        border-radius: 2em;
        transition: all 0.3s;
      }

      &:hover {
        cursor: pointer;
        color: $accent-blue;

        i {
          color: $accent-blue;
        }
      }
    }

    .filterBtn.active {
      color: $accent-blue;
      i {
        color: $accent-blue;
      }
    }
  }
}

@media only screen and (min-width: $tablet-potrait) {
  .projects {
    .filter-dropdown {
      margin-bottom: 30px;
    }
  }
}

@media only screen and (min-width: $desktop-lg) {
  .projects {
    .card-container {
      grid-template-columns: 1fr 1fr;

      grid-gap: 20px;
    }
  }
}

@media only screen and (min-width: $desktop-xlg) {
  .projects {
    .card-container {
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 40px;
    }
  }
}
</style>
